import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const LegendWrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  position: sticky;
  background: #ffffff;
  padding: 20px 60px 10px 60px;
  gap: 12px 24px;

  @media only screen and (max-width: 1024px) {
    padding: 20px 10px 5px 10px;
    gap: 6px 12px;
  }

  @media screen and (max-width: 768px) {
    padding: 20px 5px 5px 5px;
  }
`;

const LegendGroup = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const LegendItem = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Nunito Sans';
  font-size: 10px;

  @media screen and (max-width: 768px) {
    gap: 4px;
    font-size: 8px;
  }
`;

const LegendColor = styled('div')`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${(props) => props.color};
  border: ${(props) => props.border || 'none'};
`;

const CustomChartLegend = ({ baseColors, activeBuckets, showAssigned }) => {
  const vtDashView = useSelector((state) => state.volumeTrackerDashboard.ui.vtDashView);

  const hexToRgb = (hex) => {
    const cleanHex = hex.replace('#', '');
    const r = parseInt(cleanHex.substring(0, 2), 16);
    const g = parseInt(cleanHex.substring(2, 4), 16);
    const b = parseInt(cleanHex.substring(4, 6), 16);
    return `${r}, ${g}, ${b}`;
  };

  return (
    <LegendWrapper>
      {activeBuckets.map(({ key, label }, index) => {
        const color = baseColors[index % baseColors.length];
        const rgba = `rgba(${hexToRgb(color)}, 0.4)`;

        return (
          <LegendGroup key={`group-${key}`}>
            {showAssigned && (
              <LegendItem>
                <LegendColor color={rgba} border={`1px solid ${color}`} />
                Assigned
                {' '}
                {label}
              </LegendItem>
            )}
            <LegendItem>
              <LegendColor color={color} />
              {vtDashView === 'overview' ? label : `Completed ${label}`}
            </LegendItem>
          </LegendGroup>
        );
      })}
    </LegendWrapper>
  );
};

CustomChartLegend.propTypes = {
  baseColors: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeBuckets: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  showAssigned: PropTypes.bool,
};

CustomChartLegend.defaultProps = {
  showAssigned: false,
};

export default CustomChartLegend;
